import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray, NgForm } from '@angular/forms';
import { AngularTokenService } from 'angular-token';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../../utils/loader.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  resetPasswordForm: FormGroup;

  constructor(
    private tokenService: AngularTokenService,
    private formBuilder: FormBuilder,
    private loaderService: LoaderService,
    public router: Router,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.resetPasswordForm = new FormGroup({
      'email': new FormControl("", [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')])
    });
  }
  get emailAddress() {
    return this.resetPasswordForm.get('email')
  }

  onSubmit(form) {
    if (!this.resetPasswordForm.valid) { return; }
    this.loaderService.display(true);
    this.tokenService.resetPassword({ login: form.value.email }).subscribe(
      res => {
        localStorage.setItem('forgot_password_email', this.resetPasswordForm.get('email').value)
        this.router.navigate(['/forgot-password-success']);
        this.loaderService.display(false);
        this.toastr.success("Reset password instructions sent to your email.");
      },
      err => {
        this.loaderService.display(false);
        if (err.error.message) {
          this.toastr.error(err.error.message);
        } else {
          for (let i in err.error.errors) {
            this.toastr.error(err.error.errors[i]);
          }
        }
      }
    )
  }

}
